import React, { useState, useEffect, useContext } from 'react';
import { Box, Chip, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, CircularProgress } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import './vacation-bids.css'
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const VacationBidMembers = () => {
    let { id } = useParams();
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [bidList, setBidList] = useState([]);
    const [listModal, setListModal] = useState(false)
    const [vacationList, setVacationList] = useState([]);

    const columns = [
        {
            field: 'Id', headerName: 'Bid Id', flex: 1, minWidth: 200,
        },

        {
            field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    // params?.row?.employee?.EA_Rank + " " + params?.row?.employee?.fullName
                    params?.row?.employee?.fullName
                )
            }
        },
        {
            field: 'Status', headerName: 'Status', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    params?.row?.Status?.charAt(0).toUpperCase() + params?.row?.Status?.slice(1)
                )
            }
        },
        {
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 130,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <img src='/images/eye.svg' style={{ cursor: 'pointer' }} onClick={() => {
                            getVacationMember(params?.row?.employee?.Emp_Code)
                            setListModal(true)
                        }}
                        />
                    </Box>
                );
            },
        }
    ]

    const getBidListMembers = () => {
        setLoading(true)
        ApiService.get(`/vacationBid/${id}`)
            .then((data) => {
                const rowsWithIds = data?.data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                setBidList(rowsWithIds);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getVacationMember = (vacId) => {
        ApiService.get(`/vacationBid/member/${vacId}`)
            .then((data) => {
                const rowsWithIds = data?.data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                setVacationList(rowsWithIds);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getBidListMembers()
    }, [])

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) : (
                <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                    <Grid container spacing={2}>

                        {/* Heading */}
                        <Grid item xs={10} md={9}>
                            <Typography variant="h6">
                                <Link to="/firehouse/vacation-bids" style={{ color: "black" }}>
                                    <ArrowBackIosIcon />
                                </Link>
                                Vacation Bid Members</Typography>
                        </Grid>
                    </Grid>

                    {(!bidList || bidList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 600 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Bids Found
                            </span>
                        </div>
                        :
                        <>
                            <div className='mt-4'>
                                <DataGrid
                                    rows={bidList}
                                    columns={columns}
                                    checkboxSelection={false}
                                    hideFooter={true}
                                />
                            </div>
                        </>
                    }

                    {/* Vacation List Modal */}
                    <Modal size="lg" show={listModal}
                        onHide={() => {
                            setListModal(false)
                            setVacationList([])
                        }}>
                        <Modal.Body className='p-4'>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
                                    List of Vacations
                                </Typography>
                                <img src="/images/close-icon.svg" style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setListModal(false)
                                        setVacationList([])
                                    }} />
                            </div>

                            <Box id="modal-modal-description" sx={{ mt: 2 }}>
                                {loading &&
                                    <div className='my-5' style={{ display: 'flex', justifyContent: 'center' }}>
                                        <CircularProgress />
                                    </div>
                                }

                                {!loading &&
                                    <div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
                                        <TableContainer component={Paper} sx={{
                                            boxShadow: 'none !important',
                                            border: '1px solid #EAECF0',
                                            mt: 2
                                        }}>

                                            <Table aria-label="customized table">
                                                <TableHead sx={{ backgroundColor: "#E5E9EB" }} >
                                                    <TableRow>
                                                        <TableCell>Group Code</TableCell>
                                                        <TableCell>Start Date</TableCell>
                                                        <TableCell>End Date</TableCell>
                                                        <TableCell>Created at</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {vacationList.length > 0 ? vacationList.map((row) => (
                                                        <TableRow key={row?.fullName} sx={{
                                                            height: '22px',
                                                            '& .MuiTableCell-root': {
                                                                border: 'none'
                                                            },
                                                            '&:nth-of-type(even)': {
                                                                backgroundColor: 'rgba(204, 204, 204, 0.2)',
                                                            },
                                                        }}>

                                                            <TableCell component="th" scope="row">
                                                                {row?.Group_Code}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {row?.Start_Date}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {row?.End_Date}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {moment(row?.created_at).format('MM/DD/YYYY, HH:mm')}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                        :
                                                        <TableRow>
                                                            <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                                                                <div className='d-flex flex-column align-items-center justify-content-center' style={{ marginTop: 15 }}>
                                                                    <img src='/images/blur-logo.png' style={{ width: 115 }} />
                                                                    <span className='mt-4' style={{ color: '#555555' }}>
                                                                        No Vacations Found
                                                                    </span>
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                }
                            </Box>
                        </Modal.Body>
                    </Modal>
                </Paper >
            )}
        </>
    )
}

export default VacationBidMembers